import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GeneralPage from '../general/page';

export default function FlightsPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('tab') !== 'flights') {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('tab', 'flights');
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return <GeneralPage />;
}
